import { useEffect, useState } from 'react';
import { profile, changePassword } from '../../../services/authService';
// import { SETTINGS_USER_MOCK } from '../constants';

export function useUser() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchUser = async () => {
    setLoading(true);
    try {
      const data = await profile();
      setUser(data.user);
    } catch (err) {
      // setUser(SETTINGS_USER_MOCK);
      console.error('Failed to load profile:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  return {
    user,
    loading,
    refresh: fetchUser,
  };
}
